import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('FullScreenOne', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M33,6 L42,6 L42,15 M42,33 L42,42 L33,42 M15,42 L6,42 L6,33 M6,15 L6,6 L6,6 L15,6",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M6,6 L16,15.8994949",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M6,32 L16,41.8994949",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(11.000000, 36.949747) scale(1, -1) translate(-11.000000, -36.949747) "
  }), React.createElement("path", {
    d: "M42,32 L32.1005051,41.8994949",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(37.050253, 36.949747) scale(1, -1) translate(-37.050253, -36.949747) "
  }), React.createElement("path", {
    d: "M41.8994949,6 L32,15.8994949",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }))));
});